import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const createNoticePortal = async (data) => {
  const response = await axiosInstance.post("/notice-portal/create", data);
  return response.data;
};

export const getAllNoticesPortal = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.category) params.append("category", filters.category);
  if (filters.targetAudience) params.append("targetAudience", filters.targetAudience);

  const response = await axiosInstance.get(`/notice-portal/all?${params.toString()}`);
  return response.data;
};

export const getNoticeByIdPortal = async (id) => {
  const response = await axiosInstance.get(`/notice-portal/${id}`);
  return response.data;
};

export const updateNoticePortal = async (id, data) => {
  const response = await axiosInstance.put(`/notice-portal/update/${id}`, data);
  return response.data;
};

export const pinNoticePortal = async (id) => {
  const response = await axiosInstance.put(`/notice-portal/pin/${id}`);
  return response.data;
};

export const deleteNoticePortal = async (id) => {
  const response = await axiosInstance.delete(`/notice-portal/delete/${id}`);
  return response.data;
};